export default __webpack_public_path__ + "static/media/charge_pump_negative_4_diodes.29918da2.svg";